// ═══ ANYSA CUSTOM JS — Ported from anysa-html ═══

(function () {
  'use strict';

  // ── Custom cursor ──
  const cursor = document.getElementById('anCursor');
  const ring = document.getElementById('anCursorRing');
  if (cursor && ring) {
    let mx = 0,
      my = 0,
      rx = 0,
      ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top = my + 'px';
    });
    (function animRing() {
      rx += (mx - rx) * 0.13;
      ry += (my - ry) * 0.13;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(animRing);
    })();
    document.querySelectorAll('a, button').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        ring.style.width = '64px';
        ring.style.height = '64px';
        ring.style.borderColor = 'rgba(201,169,110,.55)';
      });
      el.addEventListener('mouseleave', function () {
        ring.style.width = '40px';
        ring.style.height = '40px';
        ring.style.borderColor = 'var(--an-gold)';
      });
    });
  }

  // ── Nav scroll ──
  var nav = document.getElementById('anNav');
  if (nav) {
    var lastScrollY = window.scrollY;

    function updateNav(currentScrollY) {
      nav.classList.toggle('scrolled', currentScrollY > 60);
      if (currentScrollY > 60) {
        nav.classList.toggle('nav-hidden', currentScrollY > lastScrollY);
      } else {
        nav.classList.remove('nav-hidden');
      }
      lastScrollY = currentScrollY;
    }

    // Apply correct state immediately on load
    updateNav(window.scrollY);

    window.addEventListener('scroll', function () { updateNav(window.scrollY); }, { passive: true });
  }

  // ── Hero Slider ──
  var slides = document.querySelectorAll('.an-slide');
  var indicators = document.querySelectorAll('.an-indicator');
  var counter = document.getElementById('anCounter');
  var current = 0,
    timer;

  if (slides.length) {
    function goTo(n) {
      slides[current].classList.remove('active');
      if (indicators[current]) indicators[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (indicators[current]) indicators[current].classList.add('active');
      if (counter) {
        counter.textContent =
          String(current + 1).padStart(2, '0') +
          ' / ' +
          String(slides.length).padStart(2, '0');
      }
    }
    function next() {
      goTo(current + 1);
    }
    function resetTimer() {
      clearInterval(timer);
      timer = setInterval(next, 6000);
    }

    var nextBtn = document.getElementById('anNextBtn');
    var prevBtn = document.getElementById('anPrevBtn');
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        next();
        resetTimer();
      });
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        resetTimer();
      });
    indicators.forEach(function (el, i) {
      el.addEventListener('click', function () {
        goTo(i);
        resetTimer();
      });
    });
    resetTimer();

    // touch swipe
    var tx = 0;
    var heroEl = document.getElementById('anHero');
    if (heroEl) {
      heroEl.addEventListener(
        'touchstart',
        function (e) {
          tx = e.touches[0].clientX;
        },
        { passive: true },
      );
      heroEl.addEventListener(
        'touchend',
        function (e) {
          var d = tx - e.changedTouches[0].clientX;
          if (Math.abs(d) > 50) {
            d > 0 ? next() : goTo(current - 1);
            resetTimer();
          }
        },
        { passive: true },
      );
    }
  }

  // ── Mobile menu ──
  var hamburger = document.getElementById('anHamburger');
  var mobileMenu = document.getElementById('anMobileMenu');
  var mobileOverlay = document.getElementById('anMobileOverlay');

  if (hamburger && mobileMenu) {
    function openMenu() {
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    }
    hamburger.addEventListener('click', function () {
      hamburger.classList.contains('open') ? closeMenu() : openMenu();
    });
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);
    document
      .querySelectorAll('#anMobileMenu .an-mobile-menu-links a')
      .forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    // Mobile accordion dropdowns
    document.querySelectorAll('.an-mob-dropdown').forEach(function (dd) {
      dd.querySelector('.an-mob-drop-btn').addEventListener(
        'click',
        function () {
          dd.classList.toggle('open');
        },
      );
    });
  }

  // ── Scroll reveal ──
  var revealObs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          revealObs.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
  );
  document.querySelectorAll('.an-reveal').forEach(function (el) {
    revealObs.observe(el);
  });
})();
